import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { LiveEvent } from '../../Events/EventsDTO';
import { Channel, ChannelMap } from '../../Channel/ChannelDTO';
import { useEffect, useState } from 'react';
import StreamTargetInstagramSettings from '../../InstagramSettings/InstagramSettings';

interface ChannelSettingsDrawerProps {
  liveEvent: LiveEvent;
  channels: ChannelMap;
}

const ChannelSettingsDrawer: React.FC<ChannelSettingsDrawerProps> = ({
  liveEvent,
  channels,
}) => {
  const [channel, setChannel] = useState<Channel>();
  const { t } = useTranslation();

  useEffect(() => {
    console.debug('channels', channels);
    setChannel(channels[liveEvent.code]);
  }, [channels, liveEvent.code]);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" gutterBottom>
          {t('Settings')}
        </Typography>
        <Divider />
      </Box>

      {/* Content */}
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        {channel ? (
          <StreamTargetInstagramSettings
            channel={channel}
            liveEvent={liveEvent}
          />
        ) : (
          <Box sx={{ p: 2, textAlign: 'center' }}>
            <Typography variant="body2" color="textSecondary">
              {t('Loading channel settings...')}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

const mapStateToProps = (state: any) => ({
  channels: state.channels,
});

export default connect(mapStateToProps)(ChannelSettingsDrawer);
